const t = {
  name: "Creditcard",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 14V16H4V14H10Z" fill="currentColor"/>
<path d="M0 17C0 18.6523 1.34772 20 3 20H21C22.6523 20 24 18.6523 24 17V7C24 5.34772 22.6523 4 21 4H3C1.34772 4 0 5.34772 0 7V17ZM3 6H21C21.5477 6 22 6.45228 22 7V8H2V7C2 6.45228 2.45228 6 3 6ZM22 17C22 17.5477 21.5477 18 21 18H3C2.45228 18 2 17.5477 2 17V10H22V17Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Creditcard
};
